/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

/**
 * @module LicensingModule
 */

const moduleName = 'licensing';
const componentName = 'license-summary-card';
const prefix = `${moduleName}.${componentName}`;

export const title = `${prefix}.title`;
export const cloudServicesAvailableLicensesLabel = `${prefix}.cloudServicesAvailableLicensesLabel`;
export const cloudServicesAvailableLicensesTooltipText = `${prefix}.cloudServicesAvailableLicensesTooltipText`;
export const controllerMaxAllowedLabel = `${prefix}.controllerMaxAllowedLabel`;
export const reservedLicensesLabel = `${prefix}.reservedLicensesLabel`;
export const organizationIdLabel = `${prefix}.organizationIdLabel`;

export const ENGLISH = {
    [title]: 'License',
    [controllerMaxAllowedLabel]: 'Controller Max Allowed',
    [reservedLicensesLabel]: 'Reserved Licenses',
    [cloudServicesAvailableLicensesLabel]: 'Cloud Services Available Licenses',
    [cloudServicesAvailableLicensesTooltipText]: 'Available Service Units in the Org.',
    [organizationIdLabel]: 'Organization ID',
};
